<template>
  <button class="btn customisation-option head-type" :class="part?.id" data-id="938" v-on:click="clicked">
      <span class="icon">
        <Background style="opacity: 0.6"></Background>
      </span>
    <div class="icon selected-icon">
      <BackgroundSelected/>
    </div>
    <span v-if="part.id === 'remove'" class="icon">
        <RemoveBackground></RemoveBackground>
      </span>
    <div class="icon" v-html="thumb.svg.outerHTML"></div>

  </button>
</template>

<script>
  import {BPID} from "@/enums/BodyPartIdEnum.js";

  import Background from "@/assets/image/platform/customise/bb_item.svg?inline";
  import RemoveBackground from "@/assets/image/platform/customise/thumbnail_none.svg?inline";
  import BackgroundSelected from "@/assets/image/platform/customise/bb_item_selected.svg?inline";
  import ThumbnailLibrary from "@/mixins/ThumbnailLibrary";

  export default {
    name: "CustomisationItemButton",
    components: {Background, RemoveBackground, BackgroundSelected},
    props: {
      part: Object,
      kind: String,
      buddyData: Object,
    },
    data() {
      return {
        bodyPartTypes: BPID,
        thumb: {
          id: null,
          svg: {outerHTML: null},
        }
      }
    },
    computed: {},
    mixins: [ThumbnailLibrary],
    methods: {
      closeButton() {
        this.visible = false;
      },
      clicked() {
        if (this.part) {
          this.$emit("clicked", {name: this.part.id, type: this.part.category, kind: this.kind});
        } else {
          this.$emit("clicked");
        }
      }
    },
    mounted() {

    },
    created() {
      //console.log("created")
      if (this.part && this.part.id !== 'remove') {
        ThumbnailLibrary.getThumbFromFile(this.part.id, this.buddyData.buddyConfig.grade).then(result => {
          this.thumb = result;
        });
      }
    }
  }


</script>

<style lang="scss" scoped>

  .customisation-option {
    flex: 1 1 10rem;
    flex-direction: column;
    margin: 5px;
    height: 40%;

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .title {
      width: 100%;
      height: 20%;
    }

    &.small {
      justify-content: flex-start;
      align-items: flex-start;
      padding: 0;
      margin: 5px 0;

      .icon {
        width: 50%;
      }
    }
  }

  .selected-icon {
    display: none;
  }

  .customisation-option.selected {
    .selected-icon {
      display: block;
    }
  }

</style>